import React, { memo, useMemo } from 'react';
import { Modal, Advice, Markdown } from '@Sage/hoi-poi-ui';

import { useWeb5Context } from 'lib/Web5Context';

const LimitsModal = memo(({ isOpen, onConfirm, onCancel, data, limits }) => {
    const { t } = useWeb5Context();
    const total = useMemo(() => {
        const newRows = data?.rows || 0;
        const existingRows = limits?.limitUsed || 0;
        return newRows + existingRows;
    }, [data?.rows, limits?.limitUsed]);

    return (
        <Modal
            isOpen={isOpen}
            title={t('label_import_title_alert')}
            onConfirm={onConfirm}
            confirmText={t('action_accept')}
            onCancel={onCancel}
            cancelText={t('action_cancel')}
            useCornerClose={false}
        >
            <Advice type="warning" showIcon showCollapse={false}>
                <Markdown
                    content={t('label_import_exceeding_limit_topup', [total, limits?.limit])}
                    overrides={{ a: { target: '_blank' } }}
                />
            </Advice>
        </Modal>
    );
});

export default LimitsModal;
